import React from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { FaceHappyIcon, GraphIcon, HomeIcon, PriceTagIcon } from '@motorway/mw-highway-code';

import { Content } from 'LegacySBCRA/Content/Content';

import { usePageRefEvents } from '../../../common/Hooks/usePageRefEvents';
import useBrandName from '../../hooks/useBrandName';

import LocalTexts from './UspTexts.json';

import styles from './Usp.scss';

const LocalT = new MDText(LocalTexts);

type USPProps = {
  children?: React.ReactNode;
  className?: string;
  onLoad?: () => void;
}

const USP = ({ children = null, className = '', onLoad = () => {} }: USPProps) => {
  const brandName = useBrandName();
  const vehicleEnding = LocalT.translate('usp.point1.ending');

  const { setRef } = usePageRefEvents({ onRefTrigger: onLoad });

  const renderVehicleCopy = () => {
    if (brandName?.length) {
      const lastChar = brandName[brandName.length - 1];

      return lastChar === 's' ? `${brandName}’` : `${brandName}${vehicleEnding}`;
    }

    return `${LocalT.translate('usp.point1.car')}${vehicleEnding}`;
  };

  return (
    <Content
      center
      className={cx(className, styles.component)}
      wrapper={{ className: styles.componentWrapper }}
    >
      {children}
      <ul
        ref={(ref) => setRef(ref)}
        className={ styles.usp }
        data-testid='USP'
      >
        <li>
          <div className={styles.icon}>
            <GraphIcon />
          </div>
          <h4>{LocalT.translate('usp.point1.title')}</h4>
          <p>{LocalT.translate('usp.point1.detail', { vehicle: renderVehicleCopy() })}</p>
        </li>
        <li>
          <div className={styles.icon}>
            <PriceTagIcon />
          </div>
          <h4>{LocalT.translate('usp.point2.title')}</h4>
          <p>{LocalT.translate('usp.point2.detail')}</p>
        </li>
        <li>
          <div className={styles.icon}>
            <HomeIcon />
          </div>
          <h4>{LocalT.translate('usp.point3.title')}</h4>
          <p>{LocalT.translate('usp.point3.detail')}</p>
        </li>
        <li>
          <div className={styles.icon}>
            <FaceHappyIcon />
          </div>
          <h4>{LocalT.translate('usp.point4.title')}</h4>
          <p>{LocalT.translate('usp.point4.detail')}</p>
        </li>
      </ul>
    </Content>
  );
};

export default USP;
